<template lang="pug">
.box-broad-beehive
    .container
        .box-beehive
            .box-parent.box-color-1
                .item-beehive(@click="onBoxOne($t('home.comming_soon'))")
                    .subj-name 
                        span {{$t("home.beehive.box_one")}}
            .box-parent.box-color-2
                .item-beehive(@click="onBoxTwo($t('home.comming_soon'))")
                    .subj-name 
                        span {{$t("home.beehive.box_two")}}
                .item-beehive(@click="onBoxThree($t('home.comming_soon'))")
                    .subj-name
                        span {{$t("home.beehive.box_three")}}
            .box-parent.box-color-3
                .item-beehive(@click="onBoxFour($t('home.comming_soon'))")
                    .subj-name
                        span {{$t("home.beehive.box_four")}}
                .item-beehive(@click="onBoxFive($t('home.comming_soon'))")
                    .subj-name
                        span {{$t("home.beehive.box_five")}}
                .item-beehive(@click="onBoxSix($t('home.comming_soon'))")
                    .subj-name
                        span {{$t("home.beehive.box_six")}}
        .clearfix
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import store from '../../../../store'
export default {
  components: {
    MdNotification,
    store
  },
  data() {
    return {}
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onBoxOne(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    onBoxTwo(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    onBoxThree(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    onBoxFour(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    onBoxFive(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    onBoxSix(message) {
      this.showNotification(message, 'warning', 'top', 'right', 5000)
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  apollo: {
    // lstLessons: {
    //   query: gql(graphql.GET_LESSONS_HOME),
    //   variables: {
    //     limit: 6,
    //     type_lesson: 1
    //   },
    //   update: data => {
    //     console.log('============= lesson', data.v_front_lesson)
    //     return data.v_front_lesson
    //   }
    // }
  }
}
</script>
<style lang="scss">
.content.front{
    .box-broad-beehive{margin:0 15px 30px 15px; background: url('../../../../assets/images/home/ic_bee_flying_left.png') no-repeat center center; background-size:contain; 
        .box-beehive{margin: 0 auto; text-align: center; position: relative;
            .box-parent{ padding: 43px 0;position: relative; display: flex;justify-content: center;align-items: center;
                .item-beehive{align-items: center;cursor: pointer;display: flex;position: relative;transition: all 0.2s ease;width:250px; height:150px; box-shadow: 0px 5px 5px #00000029;line-height:30px;  padding: 10px;
                    .subj-name { text-align: center;transition: all 0.2s ease;
                        span{display: block; vertical-align: middle;font-size: 27px;color:#23180A;}
                    }
                    &:after, &:before {border-left: 125px solid transparent; border-right: 125px solid transparent; content: "";left: 0; position: absolute;transition: all 0.2s ease;width: 0;}
                }
            }
            .box-color-1{
                .item-beehive{background: #FFEF45;
                    &:after, &:before { border-top-color: #FFEF45; border-bottom-color: #FFEF45;}
                    &:before{border-bottom: 70px solid #FFEF45;bottom: 100%;}
                    &:after{ border-top: 70px solid #FFEF45;top: 100%;width: 0;}
                }
            }
            .box-color-2{
                .item-beehive{background: #FBDA3E;margin-right: 20px;
                    &:last-child{;margin-right:0;}
                    &:after, &:before { border-top-color: #FBDA3E; border-bottom-color: #FFEF45;}
                    &:before{border-bottom: 70px solid #FBDA3E;bottom: 100%;}
                    &:after{ border-top: 70px solid #FBDA3E;top: 100%;width: 0;}
                }
            }
            .box-color-3{
                .item-beehive{background: #FAB32A;margin-right: 20px;
                    &:last-child{;margin-right:0;}
                    &:after, &:before { border-top-color: #FAB32A; border-bottom-color: #FFEF45;}
                    &:before{border-bottom: 70px solid #FAB32A;bottom: 100%;}
                    &:after{ border-top: 70px solid #FAB32A;top: 100%;width: 0;}
                }
            }
        }
    }
}
@media (max-width: 1366px){
    .content.front{
        .box-broad-beehive{
            .box-beehive{
                .box-color-1, .box-color-2, .box-color-3{
                    .item-beehive{
                        &:before{bottom:99%;}
                        &:after{top:99%;}
                    }
                }
            }
        }
    }
}
@media (max-width: 1024px){
    .content.front{
        .box-broad-beehive{
            .box-beehive{
                .box-color-1, .box-color-2, .box-color-3{
                    .item-beehive{
                        &:before{bottom:99%;}
                        &:after{top:99%;}
                    }
                }
            }
        }
    }
}
@media (max-width: 991px){
    .content.front{
        .box-broad-beehive{
            .box-beehive{
                .box-parent{
                    .item-beehive{width: 200px; height: 120px;
                        .subj-name{height: 100%; width:100%;display: table;
                            span{ display: table-cell;}
                        }
                        &:before, &:after{border-left: 100px solid transparent;
                            border-right: 100px solid transparent;
                        }
                    }
                }
                .box-color-1, .box-color-2, .box-color-3{
                    .item-beehive{
                        &:before{bottom:100%; border-top: 60px;}
                        &:after{top:100%;border-bottom:60px;}
                    }
                }
            }
        }
    }
}
@media (max-width: 768px){
    .content.front{
        .box-broad-beehive{margin: 0; margin-bottom:30px;
            .box-beehive{
                .box-parent{ padding: 19px 0;
                    .item-beehive{width: 110px; height: 65px; padding:0;
                        .subj-name{height: 100%; width:100%;display: table;
                            span{font-size:14px;line-height:20px; display: table-cell;}
                        }
                        &:before, &:after{border-left: 55px solid transparent;
                            border-right: 55px solid transparent;
                        }
                    }
                }
                
                .box-color-1{
                    .item-beehive{
                        &:before{border-bottom: 35px solid #FFEF45;bottom:99.5%;}
                        &:after{border-top: 35px solid #FFEF45;top:99.5%;}
                    }
                }
                .box-color-2{
                    .item-beehive{margin-right:8px;
                        &:before{border-bottom: 35px solid #FBDA3E;bottom:99.5%;}
                        &:after{border-top: 35px solid #FBDA3E;top:99.5%;}
                    }
                }
                .box-color-3{
                    .item-beehive{margin-right:8px;
                        &:before{border-bottom: 35px solid #FAB32A;bottom:99.5%;}
                        &:after{border-top: 35px solid #FAB32A;top:99.5%;}
                    }
                } 
            }
        }
    }
}

@media (max-width: 375px){
    .content.front{
        .box-broad-beehive{margin: 0; margin-bottom:30px;
            .box-beehive{
                .box-parent{ padding: 16px 0;
                    .item-beehive{width: 100px; height: 65px; padding:0;
                        .subj-name{height: 100%; width:100%;display: table;
                            span{font-size:13px;line-height:20px; display: table-cell;}
                        }
                        &:before, &:after{border-left: 50px solid transparent;
                            border-right: 50px solid transparent;
                        }
                    }
                }
                .box-color-1{
                    .item-beehive{
                        &:before{border-bottom: 30px solid #FFEF45;bottom:99%;}
                        &:after{border-top: 30px solid #FFEF45;top:99%;}
                    }
                }
                .box-color-2{
                    .item-beehive{margin-right:5px;
                        &:before{border-bottom: 30px solid #FBDA3E;bottom:99%;}
                        &:after{border-top: 30px solid #FBDA3E;top:99%;}
                    }
                }
                .box-color-3{
                    .item-beehive{margin-right:5px;
                        &:before{border-bottom: 30px solid #FAB32A;bottom:99%;}
                        &:after{border-top: 30px solid #FAB32A;top:99%;}
                    }
                } 
            }
        }
    }
}
@media (max-width: 320px){
    .content.front{
        .box-broad-beehive{margin: 0; margin-bottom:30px;
            .box-beehive{
                .box-parent{ padding: 16px 0;
                    .item-beehive{width: 90px; height: 60px; padding:0;
                        .subj-name{height: 100%; width:100%;display: table;
                            span{font-size:12px;line-height:20px; display: table-cell;}
                        }
                        &:before, &:after{border-left: 45px solid transparent;
                            border-right: 45px solid transparent;
                        }
                    }
                }
                 .box-color-1, .box-color-2, .box-color-3{
                    .item-beehive{
                        &:before{bottom:99%;}
                        &:after{top:99%;}
                    }
                }
                .box-color-1{
                    .item-beehive{
                        &:before{border-bottom: 30px solid #FFEF45;}
                        &:after{border-top: 30px solid #FFEF45;}
                    }
                }
                .box-color-2{
                    .item-beehive{margin-right:5px;
                        &:before{border-bottom: 30px solid #FBDA3E;}
                        &:after{border-top: 30px solid #FBDA3E;}
                    }
                }
                .box-color-3{
                    .item-beehive{margin-right:5px;
                        &:before{border-bottom: 30px solid #FAB32A;}
                        &:after{border-top: 30px solid #FAB32A;}
                    }
                } 
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?001a090a